import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const LineChart = (props) => {
  let { filter, series, categories } = props;

  // state

  let filteredSeries = series.filter(function (data) {
    return filter.includes(data.name);
  });

  let list = [];
  filteredSeries.forEach((item) => {
    list = [...list, ...item.data];
  });

  let listValues = list.map(function (val) {
    return parseInt(val);
  });
  let maxvalue = Math.max(...listValues);
  const [data, setData] = useState(filteredSeries);
  const [categoriesData, setCategoriesData] = useState(categories);

  useEffect(() => {
    setData(filteredSeries);
    setCategoriesData(categories);
  }, [props]);

  // console.log(categoriesData, " here is line Data");
  return (
    <div>
      <div id="chart" className="-z-10">
        <ReactApexChart
          options={{
            chart: {
              height: 350,
              type: "line",
              zoom: {
                enabled: true,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              width: 2,
              curve: "straight",
            },
            xaxis: {
              type: "date",
              categories: categoriesData,
              tickAmount: 9,
            },
            yaxis: {
              min: 0,
              max: maxvalue + 30,
            }
          }}
          series={data}
          type="line"
          height={350}
        />
      </div>
    </div>
  );
};

export default LineChart;
